// api模块
import config from "@/common/config"
import tool from "@/common/tool"
const urls ={
    openid:"/api/openid",
    jssdk:"/api/jssdk",
	upload: {
		uploadFile: "https://files.medflying.com/file_system/files",
		uploadAccept: "http://files.medflying.com/file_system/upload_accept",
		uploadBase64: "/api/uploadbase64",
		check_files: "/project/check_files"//检查文件是否重复
	},
	user: {
		login: "/user/login",
		code: "/user/send_code",
		accounts: "",
		office_departments: "",
		default_sender: "",
		permission: ""
	},
	company: {
		list: "/company/info",
		create: "/company/info",
		update: "/company/info",
		delete: "/company/info"
	},
	customerList: {
		list: "/customer/info",
		create: "/customer/info",
		update: "/customer/info",
		delete: "/customer/info",
		examine_list: "/customer/examine_info",//获取审核客户信息
		examine: "/customer/examine"//审核客户信息
	},
	accountList: {
		list: "/user/list",
		create: "/user/info",
		update: "/user/info",
		delete: "/user/info",
		bind_role: "/user/bind_role"
	},
	permissionsList: {
		all: "/permission/info",
		list: "/permission/info",
		create: "/permission/info",
		update: "/permission/info",
		disabled: "/permission/info",
		delete: "/permission/info"
	},
	roleList: {
		list: "/role/info",
		bind_permission: "/role/role_bind_permission",
		role_permission: "/role/get_role_permission",
		bind_role: "/user/bind_role",
		create: "/role/info",
		update: "/role/info",
		delete: "/role/info"
	},
	departmentList: {
		list: "/department/info",
		create: "/department/info",
		update: "/department/info",
		delete: "/department/info",
		disabled: ""
	},
	projectList: {
		list: "/project/get_project_list",
		create: "/project/create_project",
		update: "/project/update_project",
		operator_list: "/user/operator_list",//参与者列表
		delete: "",
		invite_operator: "/project/operator",
		operation_log_list: "/project/operation_log_list",//操作日志列表
		create_po_contract: "/project/create_po_contract",//新增Po合同
		update_po_contract: "/project/update_po_contract",//修改Po合同
		get_po_contract: "/project/get_po_contract",//Po合同详情
		po_audit: "/project/po_audit",//Po合同审批
		po_audit_secondary: "/project/po_audit_secondary",//Po合同二次审批
		po_executor_check: "/project/po_executor_check",//Po合同执行人确认执行
		expenses_type_list: "/project/expenses_type_list",//费用类型列表
		apply_expenses_internal: "/project/apply_expenses_internal",//内部费用支出申请(post)
		update_expenses_internal: "/project/update_expenses_internal",//内部费用支出修改(patch)
		get_expenses_internal: "/project/get_expenses_internal",//内部费用支出详情(get)
		expenses_internal_audit: "/project/expenses_internal_audit",//内部费用支出初审
		expenses_internal_audit_secondary: "/project/expenses_internal_audit_secondary",//内部费用支出二次审核
		apply_expenses_external: "/project/apply_expenses_external",//外部费用支出申请(post)
		update_expenses_external: "/project/update_expenses_external",//外部费用支出修改(patch)
		get_expenses_external: "/project/get_expenses_external",//外部费用支出修改详情(get)
		expenses_external_audit: "/project/expenses_external_audit",//外部费用支出初审
		expenses_external_audit_secondary: "/project/expenses_external_audit_secondary",//外部费用支出二次审核
		apply_seal: "/project/apply_seal",//用印申请
		apply_seal_patch: "/project/apply_seal_patch",//修改用印申请
		get_apply_seal_info: "/project/get_apply_seal_info",//获取项目用印详情
		apply_seal_audit: "/project/apply_seal_audit",//项目用印申请初审
		apply_seal_audit_secondary: "/project/apply_seal_audit_secondary",//项目用印申请二次审核
		apply_seal_executor_check: "/project/apply_seal_executor_check",//用印申请执行
		get_apply_contract_number: "/project/get_apply_contract_number",//获取项目用印申请的合同编号
		add_invoice_info: "/project/add_invoice_info",//外部费用发票上传
		audit_invoice_info: "/project/audit_invoice_info",//外部费用发票审核
		external_invoice_list: "/project/external_invoice_list",//获取项目外部发票信息
		external_invoice_audit_list: "/project/external_invoice_audit_list",//获取项目外部发票审核信息
		project_info: "/project/project_info",//查看项目号信息
		examine_project: "/project/project_examine",//项目号申请审批
		create_project_number: "/project/create_project_number",//新增项目号&操作人审批
		export_project: "/project/export_project",//导出项目
		taskAudit: "/task/task_audit"//需求发送审核
	},
	projectExecute: {
		get_task_worker_list: "/task/get_task_worker_list",//获取项目执行中Leader列表
		send_work_email: "/task/send_work_email",//发送任务邮件
		send_task_email: "/task/send_task_email",//跨部门发送任务邮件
		get_task_work_detail: "/task/get_task_work_detail",//任务分工详情,
		get_default_task_list: "/task/get_default_task_list",//默认任务列表
		get_default_task_detail: "/task/get_default_task_detail",//默认任务详情
		get_default_task_detail_id: "/task/get_default_task_detail_id",//根据ID查询默认任务详情
		add_default_task: "/task/add_default_task",//新增默认任务
		patch_default_task: "/task/patch_default_task",//修改默认任务
		delete_default_task: "/task/delete_default_task",//删除默认任务
		apply_cancel_task: "/task/apply_cancel_task",//申请撤销任务
		apply_task_check: "/task/apply_task_check"//申请撤销任务审核
	},
	settlement: {
		get_settlement_info: "/project/get_settlement_info",//获取结算基本信息
		add_settlement: "/project/add_settlement",//结算
		get_settlement_list: "/project/get_settlement_list",//获取结算列表
		get_settlement_detail: "/project/get_settlement_detail",//获取结算审核的信息
		settlement_audit: "/project/settlement_audit"//结算审核
	},
	invoice: {
		get_invoice_detail_list: "/project/invoice_detail_list",//获取发票类别列表
		add_apply_invoice: "/project/add_apply_invoice",//发票申请
		invoice_collection: "/project/invoice_collection",//发票回款列表
		invoice_payment: "/project/invoice_payment_confirmation",//发票回款确认
		get_apply_invoice: "/project/get_apply_invoice",//发票详情
		audit_apply_invoice: "/project/audit_apply_invoice",//发票初审
		audit_secondary_apply_invoice: "/project/audit_secondary_apply_invoice",//发票二审
		apply_invoice_executor_check: "/project/apply_invoice_executor_check"
	},
	staffList: {
		list: "/employee/info",
		create: "/employee/info",
		update: "/employee/info",
		delete: "/employee/info",
		examine_list: "/employee/examine_info",//获取审核员工信息
		examine: "/employee/examine"//审核员工信息
	},
	supplierList: {
		list: "/supplier/info",
		create: "/supplier/info",
		update: "/supplier/info",
		delete: "/supplier/info",
		examine_list: "/supplier/examine_info",//获取审核供应商信息
		examine: "/supplier/examine"//审核供应商信息
	},
	divideWork: {
		list: "",
		create: "",
		update: "",
		delete: ""
	},
	taskProject: {
		list: "/task/get_task_list",
		no_send_task_list: "/task/get_no_send_task",
		create: "/task/add_task",
		update: "/task/patch_task",
		delete: "",
		detail: "/task/get_task_detail"
	},
	pendingList: {
		list: "/project/get_user_operation",
		create: "",
		update: "",
		delete: ""
	},
	finishedList: {
		list: "/project/get_user_operation",
		create: "",
		update: "",
		delete: ""
	},
	passwordLook: {
		update: "/files/get_password",
		create: "",
		delete: ""
	},
	payRequestList: {
		list: "/project/get_expense_payment_order_list",
		info:"/project/get_payment_order_info",
		create: "",
		update: "",
		delete: ""
	}
}
let host = tool.isLocal() ? config.localhost : config.host;
function mergeURL(url){
    if(/^http|^https/.test(url)) return url;
    return `${host}${config.urlPrefix}${url}`;
}
for(let key in urls){
    if(typeof urls[key] == "object"){
        for(let i in urls[key]){
            urls[key][i] =  mergeURL(urls[key][i]);
        }
        continue
    }
    urls[key] = mergeURL(urls[key]);
}
export default urls;